'use es6';

import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

var _REQUEST_FUNCTION_BY_;

import PropTypes from 'prop-types';
import React, { Component } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import I18n from 'I18n';
import UIModal from 'UIComponents/dialog/UIModal';
import UIDialogCloseButton from 'UIComponents/dialog/UIDialogCloseButton';
import UIDialogBody from 'UIComponents/dialog/UIDialogBody';
import UIDialogFooter from 'UIComponents/dialog/UIDialogFooter';
import UIButton from 'UIComponents/button/UIButton';
import * as tracker from 'ui-addon-upgrades/_core/common/eventTracking/tracker';
import { requestSeatUpgrade } from 'ui-addon-upgrades/_core/upgrade/requestSeatUpgrade';
import { requestAdditionalSeats } from 'ui-addon-upgrades/_core/upgrade/requestAdditionalSeats';
import { requestSKU } from 'ui-addon-upgrades/_core/upgrade/requestSKU';
import { requestTrial } from 'ui-addon-upgrades/_core/upgrade/requestTrial';
import { requestRemoteTools } from 'ui-addon-upgrades/_core/upgrade/requestRemoteTools';
import { requestQuotePurchase } from 'ui-addon-upgrades/_core/upgrade/requestQuotePurchase';
import * as AdminModalTypes from 'ui-addon-upgrades/_core/common/constants/AdminModalTypes';
import H2 from 'UIComponents/elements/headings/H2';
import UIDialogHeader from 'UIComponents/dialog/UIDialogHeader';
import { MerchandiseIdsToUpgradeProducts } from 'self-service-api/constants/MerchandiseIdsToUpgradeProducts';
import FloatingAlertStore from 'UIComponents/alert/FloatingAlertStore';
import { getProductNameTextOrDefault } from '../adapters/getProductNameText';
import { requestProductActivation } from 'ui-addon-upgrades/_core/upgrade/requestProductActivation';
var REQUEST_FUNCTION_BY_TYPE = (_REQUEST_FUNCTION_BY_ = {}, _defineProperty(_REQUEST_FUNCTION_BY_, AdminModalTypes.REQUEST_ADDITIONAL_SEATS, requestAdditionalSeats), _defineProperty(_REQUEST_FUNCTION_BY_, AdminModalTypes.REQUEST_SEAT_UPGRADE, requestSeatUpgrade), _defineProperty(_REQUEST_FUNCTION_BY_, AdminModalTypes.REQUEST_SEAT_UPGRADE_BANNER, requestSeatUpgrade), _defineProperty(_REQUEST_FUNCTION_BY_, AdminModalTypes.REQUEST_SKU, requestSKU), _defineProperty(_REQUEST_FUNCTION_BY_, AdminModalTypes.REQUEST_TRIAL, requestTrial), _defineProperty(_REQUEST_FUNCTION_BY_, AdminModalTypes.REQUEST_QUOTE, requestQuotePurchase), _defineProperty(_REQUEST_FUNCTION_BY_, AdminModalTypes.REQUEST_REMOTE_TOOLS, requestRemoteTools), _defineProperty(_REQUEST_FUNCTION_BY_, AdminModalTypes.REQUEST_PRODUCT, requestProductActivation), _REQUEST_FUNCTION_BY_);

var getHubType = function getHubType(merchandiseId) {
  var upgradeProduct = MerchandiseIdsToUpgradeProducts[merchandiseId];
  return upgradeProduct.split('-')[0].toUpperCase();
};

var AdminModal = /*#__PURE__*/function (_Component) {
  _inherits(AdminModal, _Component);

  function AdminModal(props) {
    var _this;

    _classCallCheck(this, AdminModal);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(AdminModal).call(this, props));
    _this.handleClick = _this.handleClick.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(AdminModal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      tracker.track('viewUpgradeAdminPrompt');
    }
  }, {
    key: "handleClick",
    value: function handleClick() {
      var _this$props = this.props,
          merchandiseId = _this$props.merchandiseId,
          modalType = _this$props.modalType,
          onClose = _this$props.onClose;
      var hasRequestFunction = Object.keys(REQUEST_FUNCTION_BY_TYPE).includes(modalType);

      if (hasRequestFunction) {
        var requestFunction = modalType === AdminModalTypes.REQUEST_QUOTE ? function () {
          return requestQuotePurchase({
            hub: getHubType(merchandiseId)
          });
        } : function () {
          return REQUEST_FUNCTION_BY_TYPE[modalType]({
            merchandiseId: merchandiseId
          });
        };
        requestFunction().then(function () {
          return FloatingAlertStore.addAlert({
            message: I18n.text('upgrades.adminModal.alertNotification.success.message'),
            titleText: I18n.text('upgrades.adminModal.alertNotification.success.titleText'),
            type: 'success'
          });
        }).catch(function () {
          return FloatingAlertStore.addAlert({
            message: I18n.text('upgrades.adminModal.alertNotification.error.message'),
            titleText: I18n.text('upgrades.adminModal.alertNotification.error.titleText'),
            type: 'danger'
          });
        });
      }

      onClose();
    }
  }, {
    key: "getProductName",
    value: function getProductName() {
      var upgradeProduct = MerchandiseIdsToUpgradeProducts[this.props.merchandiseId];
      return getProductNameTextOrDefault(upgradeProduct);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          modalType = _this$props2.modalType,
          onClose = _this$props2.onClose;
      return React.createElement(UIModal, {
        size: "auto",
        width: 540,
        use: "success",
        "data-selenium": "admin-only-modal"
      }, React.createElement(UIDialogHeader, null, React.createElement(UIDialogCloseButton, {
        onClick: onClose
      }), React.createElement(H2, null, React.createElement(FormattedMessage, {
        message: "upgrades.adminModal." + modalType + ".title"
      }))), React.createElement(UIDialogBody, null, React.createElement("p", {
        className: "p-right-4"
      }, React.createElement(FormattedMessage, {
        message: "upgrades.adminModal." + modalType + ".paragraph",
        options: {
          productName: this.getProductName()
        }
      }))), React.createElement(UIDialogFooter, null, React.createElement("div", {
        "data-selenium": "admin-modal-close-button"
      }, React.createElement(UIButton, {
        className: "m-left-0",
        use: "primary",
        onClick: this.handleClick
      }, React.createElement(FormattedMessage, {
        message: "upgrades.adminModal." + modalType + ".button"
      })))));
    }
  }]);

  return AdminModal;
}(Component);

AdminModal.propTypes = {
  merchandiseId: PropTypes.number,
  modalType: PropTypes.oneOf(Object.values(AdminModalTypes || {})),
  onClose: PropTypes.func.isRequired
};
export default AdminModal;